import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PreventiveMaintenanceTriggerBasis } from '@evimo/types/enums/preventive-maintenance-trigger-basis';
import { PreventiveMaintenanceTriggerConditionType } from '@evimo/types/enums/preventive-maintenance-trigger-condition-type';

export function useStepTasksTriggerBuilderOptions() {
  const { t } = useTranslation('maintenance');

  const basisOptions = useMemo(
    () =>
      Object.values(PreventiveMaintenanceTriggerBasis).map((value) => ({
        label: t(`triggerBasis.${value}`),
        value,
      })),
    [t],
  );

  const conditionTypeOptions = useMemo(
    () =>
      Object.values(PreventiveMaintenanceTriggerConditionType).map((value) => ({
        label: t(`conditionType.${value}`),
        value,
      })),
    [t],
  );

  return { basisOptions, conditionTypeOptions };
}
